import { createKeeneyVerificationFetch } from "./keeneyVerification";
/**
 * Supabase Client — Single instance for the entire frontend.
 *
 * Reads VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY from import.meta.env.
 * If either is missing, logs a warning but still exports a client stub so the
 * dev server can run without Supabase for UI-only work. Any actual DB call
 * will fail at runtime, which is the correct behavior — no silent mock data.
 */

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const env = ((import.meta as unknown as { env?: Record<string, string | undefined> }).env ??
  (typeof process !== "undefined" ? process.env : {})) as Record<string, string | undefined>;

const supabaseUrl = env.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY as
  | string
  | undefined;

// If env vars are missing, log a warning but don't crash.
// This allows the dev server to run without Supabase for UI-only work.
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing. " +
      "Supabase calls will fail at runtime. Set these in .env.local for full functionality."
  );
}

export const supabase: SupabaseClient = createClient(
  supabaseUrl ?? "https://placeholder.supabase.co",
  supabaseAnonKey ?? "placeholder-key",
  { global: { fetch: createKeeneyVerificationFetch((input, init) => fetch(input, init), supabaseUrl ?? "https://placeholder.supabase.co") } }
);
